import axios from '@/core/http'

const fetchDistricts = () => {
  return axios.get('sources/districts/').then(res => res.data)
}

export { fetchDistricts }
